import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ConfirmationService } from 'primeng';
import { ITaskInfo } from '../../interfaces/task-info';

@Component({
  selector: 'task-step-rating',
  styleUrls: ['./task-step-rating.component.scss'],
  templateUrl: './task-step-rating.component.html',
})
export class TaskStepRatingComponent implements OnChanges {
  @Input() task: ITaskInfo;
  @Input() mode: TaskStepRatingMode = 'pickup';

  public rating: number;
  public reasons: string[];
  public comment: string;

  public wrapSize = 140;

  constructor(private confirmationService: ConfirmationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.task) {
      let mode = this.mode || 'pickup';
      let step = this.task.completeTaskSteps.find(
        (x) => x.stepType === (mode === 'pickup' ? 2 : 4),
      );
      if (step) {
        this.rating = step.rate;
        this.reasons = step.reasons ? step.reasons.map((x) => x.name) : [];
        this.comment = step.comment;

        return;
      }
    }

    this.rating = null;
    this.reasons = null;
    this.comment = null;
  }

  isShowReadMore() {
    return this.comment && this.comment.trim().length > this.wrapSize;
  }

  readMore() {
    this.confirmationService.confirm({ message: this.comment, key: this.mode });
  }
}

export type TaskStepRatingMode = 'pickup' | 'dropoff';
